import React, { memo, useEffect } from 'react';
import { Box, Grid, MenuItem } from '@mui/material';
import { useFormik } from 'formik';
import FormTextField from './FormTextField';
import FormPhoneField from './FormPhoneField';
import FormSelectField from './FormSelectField';
import { COUNTRIES, PHONE_CODES } from 'legacyfrontend/constants/countries';

const defaultInitialValues = {
  name: '',
  lastName: '',
  phone: {
    codigo: '+54',
    numero: '',
  },
  country: 'AR',
};

const EmergencyContactSection = memo(
  ({ updateEmergencyContact, index, initialValues, disabled, showEmergencyContact }) => {
    const formik = useFormik({
      initialValues: initialValues || defaultInitialValues,
      validateOnMount: false,
      validateOnChange: false,
      validateOnBlur: false,
    });

    // Reset form when showEmergencyContact changes
    useEffect(() => {
      if (!showEmergencyContact) {
        formik.resetForm();
        updateEmergencyContact(index, null, false);
      }
    }, [showEmergencyContact, index, updateEmergencyContact]);

    const handleFieldChange = (e) => {
      formik.handleChange(e);

      // Solo actualizamos si hay algún valor ingresado
      const hasValues = Object.values(formik.values).some((value) =>
        typeof value === 'string'
          ? value.trim() !== ''
          : typeof value === 'object'
            ? Object.values(value).some((v) => v.trim() !== '')
            : false
      );

      if (hasValues) {
        const emergencyContactData = {
          ...formik.values,
          country: formik.values.country || 'AR',
        };
        updateEmergencyContact(index, emergencyContactData, false);
      } else {
        updateEmergencyContact(index, null, false);
      }
    };

    return (
      <Box sx={{ p: 3, pt: 1, bgcolor: 'white', borderRadius: 1, width: '100%' }}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <FormTextField
                  disabled={disabled}
                  formik={formik}
                  label='Nombre'
                  name='name'
                  onChange={handleFieldChange}
                  placeholder='Ingrese el nombre'
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <FormTextField
                  name='lastName'
                  label='Apellidos'
                  placeholder='Ingrese los apellidos'
                  formik={formik}
                  disabled={disabled}
                  onChange={handleFieldChange}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} md={6}>
            <FormPhoneField
              name='phone'
              label='Teléfono'
              formik={formik}
              disabled={disabled}
              codigosPais={PHONE_CODES}
              onChange={handleFieldChange}
              codigoWidth='40%'
              numeroWidth='60%'
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <FormSelectField
              disabled={disabled}
              formik={formik}
              label='País'
              name='country'
              onChange={handleFieldChange}
            >
              {COUNTRIES.map((country) => (
                <MenuItem key={country.code} value={country.code}>
                  {country.name}
                </MenuItem>
              ))}
            </FormSelectField>
          </Grid>
        </Grid>
      </Box>
    );
  }
);

EmergencyContactSection.displayName = 'EmergencyContactSection';

export default EmergencyContactSection;
